import { gql, useMutation } from "@apollo/client";
import { NormalizedErrorMap } from "../../../../types/NormalizedErrorMap";
import React, { ReactElement } from "react";
import {
  CreateIndustryMutationMutation,
  CreateIndustryMutationMutationVariables
} from "../../../../schemaTypes";
import { normalizeErrors } from "../../../../utils/normalizeErrors";

export const createIndustryMutation = gql`
  mutation CreateIndustryMutation(
    $name: String!
) {
    createIndustry(
        name: $name
    ) {
    errors {
        path
        message
    }
    message
    }
}
`;

interface Props {
  children: (
    data: {
      submitCreateIndustry: (
        values: CreateIndustryMutationMutationVariables
      ) => Promise<NormalizedErrorMap | any>;
      loading: boolean;
      error: any;
      message: string | null;
      createIndustryData: any | null;
    }
  ) => ReactElement | null;
}

export const CreateIndustryController: React.FC<Props> = ({ children }) => {
  const [mutate, { loading, error, data }] = useMutation<
    CreateIndustryMutationMutation,
    CreateIndustryMutationMutationVariables
  >(createIndustryMutation);

  const submitCreateIndustry = async (values: CreateIndustryMutationMutationVariables) => {
    const { data: { createIndustry } }: any = await mutate({ variables: values });

    if (createIndustry?.errors) {
      return { error: normalizeErrors(createIndustry.errors), createIndustry: null };
    }

    return {
      error: null,
      createIndustry
    };
  };

  const message = data?.createIndustry?.message || null;

  return children({
    submitCreateIndustry,
    loading,
    error,
    message,
    createIndustryData: data,
  });
};
